import React from 'react'
import { Container } from '@mui/material'
import Registrar from './Registrar'

const Registro = () => {
  return (
    <div>
      <Container >
        <Registrar />
      </Container>
    </div>
  )
}

export default Registro